import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '@auth0/auth0-angular';
import { OverviewContainerComponent } from './containers/overview-container/overview-container.component';

const routes: Routes = [
  {
    path: 'overview',
    component: OverviewContainerComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'applications',
        pathMatch: 'full'
      },
      {
        path: 'applications',
        loadComponent: () =>
          import(
            '@containers/application-container/application-container.component'
          ).then((m) => m.ApplicationContainerComponent),
        data: { label: 'applicationView', view: 'application' },
        canActivate: [AuthGuard]
      }
    ]
  },
  // Lazy-loaded standalone component
  {
    path: 'status',
    loadComponent: () =>
      import('./containers/status-container/status-container.component').then(
        (m) => m.StatusContainerComponent
      )
  },
  {
    path: '',
    redirectTo: 'overview',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
